<div class="dialog-content-wrapper" [ngClass]="'dialog-content-wrapper--' + variant()">
  <div class="dialog-content">
    @if (internalIcon()) {
      <div class="dialog-content__icon">
        <tngh-svg-icon [name]="internalIcon()!" />
      </div>
    }
    <div class="dialog-body">
      <h2 class="dialog-body__title">{{ title() }}</h2>
      <div class="dialog-body__content">
        <ng-content select="[dialog-body]" />
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <ng-content select="[dialog-footer]" />
  </div>
</div>
